import { Center, Spinner } from '@chakra-ui/react';

export const Loader = () => (
  <Center>
    <Spinner
      color="brand.secondary.swatch4"
      emptyColor="brand.primary.lightGrey"
      label="loading"
      size="xl"
      speed="0.5s"
      thickness="4px"
    />
  </Center>
);
